module.exports = "/_next/static/images/ourPartnersLogo4-14efd50149cf9d04a39a2f139e33b4ba.webp";